export const MODULE_NAME = 'companyDashboard';
